// Copyright 2023 andrewzeck
// 
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
// 
//     http://www.apache.org/licenses/LICENSE-2.0
// 
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
import React, { lazy, Suspense, useEffect, useState } from 'react';
import { getPipelineEvents } from "../../api";
import _ from "lodash";
import moment from "moment-timezone";
import styles from "assets/jss/material-dashboard-pro-react/components/tableStyle";
import { makeStyles, withStyles } from "@material-ui/core/styles";


import { connect } from "react-redux";
import { 
  Box, 
  Grid, 
  Chip, 
  CircularProgress, 
  LinearProgress,
  Paper,
 } from "@material-ui/core";

import Extension from "@material-ui/icons/Extension";
import Overlay from "../../components/Overlay/Overlay";
import Timeline from "../../components/Timeline/Timeline";

const useStyles = makeStyles(styles);

class EventTimeline extends React.Component {
  state = {
    events: [],
    loading: true
  };
  _loadEvents(storeId){
    getPipelineEvents(storeId).then((results)=>{
      if(results && results.data){
        console.log('loaded events:', results.data.length)
        this.setState({ events: results.data, loading: false });
      }
    })
  }
  tick = () => {
    this._loadEvents();
  }
  componentDidMount(){
    this.interval = setInterval(this.tick, 10000);
    this._loadEvents();
  }
  componentWillUnmount(){
    console.log('will unmount');
    clearInterval(this.interval);
  }
  render(){
    /*<TimelineList title="Pipeline Events">
        {events.length && (
          events.map((item)=>{
          <TimelineItem
            color="success"
            icon="notifications"
            title={item.display}
            dateTime={moment(item.created).format("DD MMM hh:mm a")}
            description={item.display}
            badges={["design"]}
          />
          })
        )}
        </TimelineList>*/
    const { events, loading } = this.state;
    const { classes } = this.props;
    let data = events.map((item)=>{
      return {
        // Second story
        inverted: false,
        badgeColor: "success",
        badgeIcon: Extension,
        title: `${item.store_id} ${item.name}`,
        titleColor: "success",
        body: (
          <p>
            {`${item.matches}/${item.rows} Matches`}<br></br>
            {`Updates:${item.updated_rows}`}<br></br>
          </p>  
        ),
        footerTitle: `${moment(item.created).format('DD MMM HH:mm')}`
      };
    })
    return (
      <>
        {loading && <Overlay type="loading" />}
        <Timeline stories={data} simple/>
      </>  
    )
  }
}
export default connect((state) => ({ user: state.app.user }))(
  withStyles(styles)(EventTimeline)
);